import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  GET_RICHMENUTEMPLATE: function (state, payload) {
    state.richmenuTemplate = payload
  },
  GET_PRESETMENU: function (state, payload) {
    state.presetMenu = payload
  },
  SET_LINERICHMENU: function (state, payload) {
    state.lineRichMenu = payload
  },
  SET_TEMPLATESELECT: function (state, payload) {
    if (typeof payload.content_json === 'string') {
      // console.log(payload.content_json);
      payload.content_json = JSON.parse(payload.content_json)
    }
    state.templateSelect = payload
  },
  SET_UPLOADSELECTTYPE: function (state, payload) {
    state.uploadSelectType = payload
  },
  SET_TYPEEDITNEW: function (state, payload) {
    state.setTypeEditNew = payload
  },
  SET_IMAGESELECT: function (state, payload) {
    state.imageSelect = payload
  },
  SET_IDTEMPLATE: function (state, payload) {
    state.idTemplate = payload
  },
  SET_SCALE: function (state, payload) {
    state.scale = payload
  },
  DELETE_RICHMENU: function (state, id) {
    state.lineRichMenu = state.lineRichMenu.filter((item) => item.id !== id)
    // console.log(state.lineRichMenu);
  },
  SET_PACKAGERICHMENU: function (state, payload) {
    state.packageRichmenu = payload
  },
  SET_SELECT_GROUPID: function (state, payload) {
    state.groupId = payload
  },
  SET_CHECKCLICKTRIAL: function (state, payload) {
    state.clickTrial = payload
  }
}
